import React from "react";
import { PureAppComponent } from "../../../Components/AppComponent";
import {
  Form,
  Button,
  InputGroup,
  FormControl,
  ButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import api from "../../../Services/Api/api";
import AgentReceiptGrouped from "./AgentReceiptGrouped";

const SCREEN_NAME = "ACCOUNT_PRINT_CUSTOER_RECEIPT_SCREEN";

class PrintAgentReceiptInner extends PureAppComponent {
  constructor(props) {
    super(props);

    const refDate = new Date().setMonth(new Date().getMonth() - 1);
    this.state = {
      loading: false,
      error: null,
      data: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date(refDate).getMonth(),
      year: new Date(refDate).getFullYear(),
      index: this.props.index,
      agent: this.props.agent,
    };

    this.months = "January, February, March, April, May, June, July, August, September, October, November, December"
      .split(",")
      .map((x) => x.trim());

    this.componentRef = React.createRef(null);
  }

  componentDidMount() {
    this.onMount();
    this.onSubmit();
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });

      const agent = { ...this.state.agent };

      const res = await api.get("v1/commission", {
        queryStr: JSON.stringify({
          where: {
            agent: agent._id,
            t: { $gte: range0, $lt: range1 },
          },
          populate: "transaction account",
        }),
      });

      let commissions = this.groupCommissions(res);

      this.setAsyncState({
        data: {
          commissions,
          agent,
          range: [range0, range1],
          total: {
            _id: "total",
            amount: res.commissions
              ?.map((x) => x.amount || 0)
              .reduce((a, b) => a + b, 0),
            transction: {
              amount: res.commissions
                ?.map((x) => x.transaction?.amount || 0)
                .reduce((a, b) => a + b, 0),
            },
          },
        },
        loading: false,
      });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  getMonthDiff(d1, d2) {
    const m1 = new Date(d1).getFullYear() * 12 + new Date(d1).getMonth();
    const m2 = new Date(d2).getFullYear() * 12 + new Date(d2).getMonth();
    return m2 - m1;
  }

  groupCommissions({ commissions }) {
    let groups = {};

    for (let i = 0; i < commissions.length; i++) {
      const item = commissions[i];

      const accountType = item.account?.accountType;
      const monthDiff =
        accountType === "deposit"
          ? this.getMonthDiff(
              item.account?.openingDate,
              item.account?.endingDate
            )
          : 0;
      const commissionRate = item.account?.collectorCommission;

      const key = `${accountType}-${monthDiff}-${commissionRate}`;

      if (!groups[key]) {
        groups = {
          ...groups,
          [key]: {
            _id: key,
            accountType,
            monthDiff,
            commissionRate,
            trAmount: 0,
            commissionAmount: 0,
          },
        };
      }

      groups[key].trAmount =
        groups[key].trAmount + (item.transaction?.amount || 0);
      groups[key].commissionAmount = groups[key].commissionAmount + (item.amount || 0);
    }

    // console.log({ groups });
    return Object.values(groups)
  }

  nextAgent(n) {
    const {
      props: { agents },
      state: { index },
    } = this;
    let nextIndex = index + n;

    nextIndex = Math.min(agents.length - 1, nextIndex);
    nextIndex = Math.max(0, nextIndex);

    const newState = {
      index: nextIndex,
      agent: agents[nextIndex],
    };

    this.setAsyncState(newState).then(() => this.onSubmit());

    if (agents.length - nextIndex < 4) {
      this.props.loadMore?.();
    }
  }

  reactToPrintTrigger = () => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button size="sm" variant="secondary">
          Print
        </Button>
      </div>
    );
  };

  renderInner() {
    const {
      state: {
        loading,
        error,
        month,
        year,
        period,
        range0,
        range1,
        data,
        index,
        agent,
      },
      props: { multipleAgents = false, agents },
    } = this;

    return (
      <div className="agent-receipt">
        {error ? <div className="errormsg">{error}</div> : null}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.onSubmit();
          }}
        >
          <ButtonGroup className="mb-3">
            {[
              { name: "Monthly", value: "monthly" },
              { name: "Custom", value: "custom" },
            ].map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`agent-reciept-range-radio-${idx}`}
                type="radio"
                variant={"outline-success"}
                name="radio"
                value={radio.value}
                checked={period === radio.value}
                onChange={(e) =>
                  this.setAsyncState({ period: e.currentTarget.value })
                }
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
          {loading ? <span className="m-3">Loading...</span> : null}

          {period === "monthly" ? (
            <InputGroup className="mb-3">
              <FormControl
                value={month || ""}
                onChange={(e) => this.setState({ month: e.target.value })}
                as="select"
                required
              >
                <option value="">Select Month</option>
                {this.months.map((x, i) => (
                  <option key={i} value={i}>
                    {x}
                  </option>
                ))}
              </FormControl>
              <FormControl
                type="number"
                value={year || ""}
                onChange={(e) => this.setState({ year: e.target.value })}
                placeholder="Year"
                required
              />

              <Button disabled={loading} type="submit">
                Generate
              </Button>
            </InputGroup>
          ) : (
            <InputGroup className="mb-3">
              <FormControl
                type="date"
                value={range0 || ""}
                onChange={(e) => this.setState({ range0: e.target.value })}
                placeholder="From Date"
                required
              />

              <FormControl
                type="date"
                value={range1 || ""}
                onChange={(e) => this.setState({ range1: e.target.value })}
                placeholder="To Date"
                required
              />

              <Button disabled={loading} type="submit">
                Generate
              </Button>
            </InputGroup>
          )}
        </Form>

        {multipleAgents ? (
          <div
            style={{
              marginBottom: "-26px",
              textAlign: "right",
              marginRight: "50px",
            }}
          >
            <span>
              {index + 1}/{agents?.length}
            </span>{" "}
            <Button
              size="sm"
              onClick={() => this.nextAgent(-1)}
              disabled={index <= 0}
            >
              Prev
            </Button>{" "}
            <Button size="sm" onClick={() => this.nextAgent(1)}>
              Next
            </Button>
          </div>
        ) : null}

        {data ? (
          <>
            <ReactToPrint
              content={() => this.componentRef.current}
              documentTitle={`recovery-receipt-${agent?._id}`}
              // onAfterPrint={this.handleAfterPrint}
              // onBeforeGetContent={this.handleOnBeforeGetContent}
              // onBeforePrint={this.handleBeforePrint}
              removeAfterPrint
              trigger={this.reactToPrintTrigger}
            />

            <div
              style={{
                border: "1px solid lightgray",
                boxShadow: "lightgrey 3px 3px 9px",
              }}
            >
              <AgentReceiptGrouped
                ref={this.componentRef}
                data={data}
                key={agent?._id}
              />
            </div>
          </>
        ) : null}
      </div>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: `Agent Receipt`,
          // showFooter: false,
          showSubmitBtn: false,
          modalProps: {
            size: "md",
            scrollable: true,
            backdrop: true,
          },
        }}
      >
        {this.renderInner()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderInner();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const PrintAgentReceipt = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintAgentReceiptInner);

export default PrintAgentReceipt;
